jQuery(document).ready(function($) {
	var initAnimatedSvg = function() {
		var $this = $(this), animation = $this.data('animation'), $tile = $this.parent();
		switch (animation) {
			case 'play':
				$tile.on('mouseover', runPlayAnimation).on('mouseout', reversePlayAnimation);
				break;
		}
	};

	var reversePlayAnimation = function() {
		var s = Snap(this);
		var dashedEllipse = s.select('#Ellipse_4');
		var line9 = s.select('#Line_9');
		/*
		dashedEllipse.transform('t54.419,40.091');
		dashedEllipse.transform('r45,54.419,40.091');
		*/
		/*
		Works but not translated
		dashedEllipse.animate({ transform: 'r0,6.981,7.339' }, 1000);
		 */
		dashedEllipse.animate({ transform: 'r0,62.451,48.481' }, 1000);
		//dashedEllipse.transform('r0,54.419,40.091');
		//dashedEllipse.animate({ transform: "r45 54.419 40.091" }, 1000);
		line9.animate({ transform: 'r0,43.977,46.34 '}, 1000);
	};

	var runPlayAnimation = function() {
		var s = Snap(this);
		//var circle = s.circle(54,40,10);
		var dashedEllipse = s.select('#Ellipse_4');
		var line9 = s.select('#Line_9');
		/*
		Works but not translated
		dashedEllipse.transform('r0,6.981,7.339');
		dashedEllipse.animate({ transform: 'r-45,6.981,7.339' }, 1000);
		 */
//		dashedEllipse.transform('t54.419,40.091');
		//dashedEllipse.transform('r0,62.451,48.481');
		dashedEllipse.animate({ transform: 'r-45,62.451,48.481' }, 1000);
		line9.animate({ transform: 'r45,43.977,46.34 '}, 1000);
	};

	$('.animated').each(initAnimatedSvg);
});